import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "marks" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["settings-slider", {'above-zero': _ctx.value > 0, greyed: $props.greyed}])
  }, [
    _createVNode(_component_Slider, {
      modelValue: _ctx.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.value) = $event)),
      class: "slider",
      step: 1,
      "show-tooltip": false
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "mark pointer",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.value = 0))
      }, " High Impact "),
      _createElementVNode("div", {
        class: "mark pointer",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.value = 50))
      }, " Balanced "),
      _createElementVNode("div", {
        class: "mark pointer",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.value = 100))
      }, " Everything ")
    ])
  ], 2 /* CLASS */))
}